var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7109 9.0625C18.7109 8.0783 18.32 7.13441 17.624 6.43847C16.9281 5.74254 15.9842 5.35156 15 5.35156C14.0158 5.35156 13.0719 5.74254 12.376 6.43847C11.68 7.13441 11.2891 8.0783 11.2891 9.0625C11.2891 10.0467 11.68 10.9906 12.376 11.6865C13.0719 12.3825 14.0158 12.7734 15 12.7734C15.9842 12.7734 16.9281 12.3825 17.624 11.6865C18.32 10.9906 18.7109 10.0467 18.7109 9.0625ZM9.0625 9.0625C9.0625 7.48778 9.68806 5.97755 10.8016 4.86405C11.9151 3.75056 13.4253 3.125 15 3.125C16.5747 3.125 18.0849 3.75056 19.1984 4.86405C20.3119 5.97755 20.9375 7.48778 20.9375 9.0625C20.9375 10.6372 20.3119 12.1474 19.1984 13.2609C18.0849 14.3744 16.5747 15 15 15C13.4253 15 11.9151 14.3744 10.8016 13.2609C9.68806 12.1474 9.0625 10.6372 9.0625 9.0625ZM6.89624 24.6484H23.1038C22.6909 21.7122 20.1675 19.4531 17.1199 19.4531H12.8801C9.83252 19.4531 7.30908 21.7122 6.89624 24.6484ZM4.60938 25.4973C4.60938 20.9282 8.31104 17.2266 12.8801 17.2266H17.1199C21.689 17.2266 25.3906 20.9282 25.3906 25.4973C25.3906 26.2581 24.7737 26.875 24.0129 26.875H5.98706C5.22632 26.875 4.60938 26.2581 4.60938 25.4973Z",
    fill: "#334155"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.6eb53aebf0a438bcdf871dd22a485865.svg";
export { ForwardRef as ReactComponent };